import * as actions from './actions';
import * as userActions from '../../users/state/actions';
import { Action, createReducer, on } from '@ngrx/store';
import { User } from '../../models/User';
import {HelpPost} from "../../interfaces/help-post.interface";

export interface AuthState {
  user: User | null;
  unreadHelpPosts: HelpPost[];
  practiceAccessLoading: boolean;
  practiceAccessError: any | null;
  grantedPracticeId: string | null;
}

export const initialState: AuthState = {
  user: null,
  unreadHelpPosts: [],
  practiceAccessLoading: false,
  practiceAccessError: null,
  grantedPracticeId: null,
};

const authReducer = createReducer(
  initialState,
  on(actions.StoreUser, (state, payload) => ({
    ...state,
    user: payload.user
  })),
  on(actions.RemoveUser, (state, payload) => ({
    ...state,
    user: null
  })),
  on(userActions.CompleteTourSuccess, (state) => {
    if(state.user) {
      return {
        ...state,
        user: {...state.user, tourComplete: true}
        }
    }
    return state
  }),
  on(actions.StoreUnreadPosts, (state, payload) => ({
    ...state,
    unreadHelpPosts: payload.posts
  })),
  on(actions.GrantPracticeAccess, (state, payload) => ({
    ...state,
    practiceAccessLoading: true,
    practiceAccessError: null,
    grantedPracticeId: null
  })),
  on(actions.GrantPracticeAccessSuccess, (state, payload) => ({
    ...state,
    practiceAccessLoading: false,
    practiceAccessError: null,
    grantedPracticeId: payload.practiceId
  })),
  on(actions.GrantPracticeAccessNoop, (state) => ({
    ...state,
    practiceAccessLoading: false,
    practiceAccessError: null,
    grantedPracticeId: "0"
  })),
  on(actions.GrantPracticeAccessFailure, (state, payload) => ({
    ...state,
    practiceAccessLoading: false,
    practiceAccessError: payload.error,
    grantedPracticeId: null
  }))
);

export function reducer(state: AuthState | undefined, action: Action): AuthState {
  return authReducer(state, action);
}
